"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-unsafe-call */
const dynamic_1 = __importDefault(require("next/dynamic"));
const lazy_hydrate_1 = __importDefault(require("./lazy-hydrate"));
const EmptyComp = () => null;
function lazyLoadHydrate(module, option = {
    on: [],
    loading: EmptyComp,
}) {
    return (0, lazy_hydrate_1.default)({
        on: option.on,
        onBefore: module,
        compatibleMode: option.compatibleMode,
        wrapperProps: Object.assign({}, option.wrapperProps),
    })((0, dynamic_1.default)(module, {
        loading: option.loading || EmptyComp,
        ssr: true,
    }));
}
exports.default = lazyLoadHydrate;
